import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import MuiModal from "../../shares/MuiModal";
import OrderCardLeftPart from "./OrderCardLeftPart";
import POrderCardLeftPart from "../../admin-panels/producers/create-order-new/POrderCardLeftPart";
import CreateOrderCard from "../../shares/CreateOrderCard";

// import Others files

const AddOrderModal = (props) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-11/12"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>
          <CreateOrderCard ring={props.item}>
            {props.producerCreateOrder ? (
              <POrderCardLeftPart
                item={props.item}
                hasOpenModal
                setOpenModal={props.setOpenModal}
              />
            ) : (
              <OrderCardLeftPart
                item={props.item}
                hasOpenModal
                setOpenModal={props.setOpenModal}
              />
            )}
          </CreateOrderCard>
        </div>
      </MuiModal>
    </>
  );
};

export default AddOrderModal;
